import React, { useEffect, useState } from "react";

import css from "./TitledInput.module.scss";

export type TitledInputProps = React.PropsWithChildren & {
  required?: boolean;
  title: string;
  onClick?: () => void;
  onPointerDown?: () => void;
  style?: React.CSSProperties;
};

export const TitledInput: React.FC<TitledInputProps> = ({
  required = false,
  title,
  children,
  style,
  ...props
}) => {
  return (
    <div
      style={{ textAlign: "left", margin: "0.5rem 1rem", ...style }}
      onClick={props.onClick}
      onPointerDown={props.onPointerDown}
    >
      <h4 style={{ margin: "0", marginBottom: ".25rem" }}>
        <b>
          {required && (
            <span style={{ color: "var(--gm-color-primary-highlight)" }}>
              <b>* </b>
            </span>
          )}
          {title}
        </b>
      </h4>
      {children}
    </div>
  );
};
